module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Heads up!',
      "size": 'sm',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "ph3",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('p', [_vm._v("\n      Your co-teachers in this Parlay Course might not be co-teachers in the\n      "), _c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.integration.provider_name) + " ")]), _vm._v(" course that you\n      have connected "), _c('span', {
    staticClass: "b"
  }, [_vm._v(" (" + _vm._s(_vm.integration.course_name) + ") ")]), _vm._v(".\n    ")]), _vm._v(" "), _vm._l((_vm.integration.teachers), function(teacher) {
    return _c('p', {
      key: teacher,
      staticClass: "b"
    }, [_vm._v("\n      " + _vm._s(teacher) + "\n    ")])
  }), _vm._v(" "), _c('p', [_vm._v("\n      They will still be able to perform everything in Parlay, but they won't\n      be able to sync assignments or assessment data with your\n      " + _vm._s(_vm.integration.provider_name) + " class.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      If you want them to able to this, add them as a co-teacher inside your\n      " + _vm._s(_vm.integration.provider_name) + " class as well.\n    ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "pv2"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    staticStyle: {
      "font-size": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Okay, Got it.\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3f86d918!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/integrationTeacherNotInCourseModal.vue
// module id = 2219
// module chunks = 61